/* eslint-disable react/prefer-stateless-function */
/* eslint-disable max-len */
import React, { Component } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import logo from 'assets/images/logo/logoXpoPRO.png';
import 'react-toastify/dist/ReactToastify.css';
import PropTypes from 'prop-types';

// Two types classroom view or webinar view, changes background and chat component
export default class SessionItemView extends Component {
  render() {
    const { url } = this.props.match;
    console.log(url);
    return (
      <div className="sessionItemView">

        <div className="gradient" />
        <div className="bg" />

        <div className="sessionItemHolder">

          <div className="video">
            {url === '/main/breakout-sessions/class/30 minutes' &&
              <video
                src="https://front.travpromobile.com/614/TravPRO TRAINING [Advisors].mp4"
                autoPlay
                preload="auto"
                height="100%"
                width="100%"
                controls
              >
                <track kind="captions" />
              </video>
            }
            {url === '/main/breakout-sessions/class/23 minutes' &&
            <video
              src="https://front.travpromobile.com/614/bigmarker-recording.mp4"
              autoPlay
              preload="auto"
              height="100%"
              width="100%"
              controls
            >
              <track kind="captions" />
            </video>
          }
            {url === '/main/breakout-sessions/class/25 minutes' &&
            <video
              src="https://front.travpromobile.com/614/zoom_0.mp4"
              autoPlay
              preload="auto"
              height="100%"
              width="100%"
              controls
            >
              <track kind="captions" />
            </video>
        }
            <div className="title">
              <span>Visit California Webinar Series</span>
              <div className="subtitle">
                Join us as we take you through Northern California. Learn about our volcanoes (yes, we have 3 of them), world class wineries, beaches, cities with amazing diners and Michelin star chefs, and many more Insider Tips located throughout undiscovered Northern California. In addition to insider tips on the destination, we'll also be sharing insider tips on how you can easily sell Northern California!
              </div>
            </div>
          </div>

          <div className="speakerHolder">
            <img className="user__image" alt="user" src="https://travpromobile.com/images/jenn.png" />
            <div className="user">Jennifer Belz</div>
            <div className="sub">VP Marketing and Client Services</div>
            <hr />
            <div className="socials">
              <span>Connect with me:</span>
              <div className="social__items">
                <a href="mailto:jbelz@travpromobile.com">
                  <FontAwesomeIcon icon={['fas', 'envelope']} />
                </a>
                <a href="https://www.zoominfo.com/p/Jennifer-Belz/-1466788390" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={['fab', 'linkedin']} />
                </a>
              </div>
            </div>
          </div>

        </div>
        <div className="bottom__bar" />
      </div>
    );
  }
}


SessionItemView.propTypes = {
  match: PropTypes.shape().isRequired,
};
